import { createFileRoute } from '@tanstack/react-router';
import { choicesReadGuard } from '@bmwe/ui';
import { ChoiceTypeManagement } from '../../../features/choices/choiceTypeManagement';

export const Route = createFileRoute('/auswahlfelder/transportrouten/')({
  component: () => (
    <ChoiceTypeManagement
      choiceTypeKey="Types"
      returnRoute="/auswahlfelder/types"
    />
  ),
  beforeLoad: choicesReadGuard,
});

export const TypesRoute = Route;
